import { fork } from 'redux-saga/effects';
import watchChangeTicket from './watchChangeTicket';
import watchResearchSchedule from './watchResearchSchedule';

export default function* scheduledRides() {
  yield fork(watchChangeTicket);
  yield fork(watchResearchSchedule);
}
